var _rect, _clipPath, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapsPulci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Google Maps",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "50%",
    fill: "white"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 136a133 133 0 00-79-66 136 136 0 00-40-6 133 133 0 00-103 48 133 133 0 00-31 86c0 38 13 64 13 64 15 32 42 61 61 86a399 399 0 0130 45 222 222 0 0117 42c3 10 6 13 13 13s11-5 13-13a228 228 0 0116-41 472 472 0 0145-63c5-6 32-39 45-64 0 0 15-29 15-68 0-37-15-63-15-63z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 130,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fbbc04",
    d: "M104 379l152-181"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4285f4",
    d: "M256 198L378 53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#34a853",
    d: "M189 459l243-290"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a73e8",
    d: "M255 120l-79-67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ea4335",
    d: "M76 232l91-109"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 198,
    r: 51,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsPulci);
export default __webpack_public_path__ + "static/media/mapsPulci.1696754689485b10c14d77daefc2ea95.svg";
export { ForwardRef as ReactComponent };